import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

type StyleProps = {
  disableBorders: boolean
}

export const useStyles = makeStyles<StyleProps>()(
  ({ spacing, palette }, { disableBorders }) => ({
    layoutContainer: {
      display: "flex",
      justifyContent: "center",
      height: "100%",
      width: "100%",

      // Apply borders to children like ScreenView does
      "& > div": {
        "&.SingleColumn": {
          borderLeft: disableBorders ? "none" : `1px solid ${blueGrey[100]}`,
          borderRight: disableBorders ? "none" : `1px solid ${blueGrey[100]}`,

          "@media (max-width: 860px)": {
            borderLeft: "none",
            borderRight: "none"
          }
        },

        // For split columns - first child gets left and right border (middle divider)
        "&:first-of-type:not(.SingleColumn)": {
          borderLeft: disableBorders ? "none" : `1px solid ${blueGrey[100]}`,
          borderRight: disableBorders ? "none" : `1px solid ${blueGrey[100]}`
        },

        // Last child in split columns gets right border
        "&:last-child:not(.SingleColumn):not(:first-of-type)": {
          borderRight: disableBorders ? "none" : `1px solid ${blueGrey[100]}`
        }
      }
    },
    columnWrapper: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: palette.background.paper,
      overflow: "hidden",
      height: "100%"
    },
    column: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: palette.background.paper,
      // overflow: "auto"
      overflow: "hidden",
      flex: 1,
      minHeight: 0
    },
    columnContent: {
      padding: spacing(2, 6, 6, 6),
      flex: 1,
      overflow: "auto",
      minHeight: 0
    },
    full: {
      width: "100%",
      maxWidth: "860px",
      flexGrow: 0
    },
    balanced: {
      width: "50%",
      flexGrow: 1
    },
    large: {
      width: "60%",
      flexGrow: 0
    },
    small: {
      width: "40%",
      flexGrow: 0,
      flexShrink: 0
    },
    mobileColumn: {
      // width: "100%",
      // padding: spacing(3)
      padding: spacing(0, 6, 6, 6),
      flex: 1,
      overflow: "auto"
    },
    titleContainer: {
      padding: spacing(2, 6),
      borderBottom: disableBorders ? "none" : `1px solid ${blueGrey[100]}`
    },
    titleContainerFull: {
      padding: spacing(5, 6),
      borderBottom: disableBorders ? "none" : `1px solid ${blueGrey[100]}`,

      "@media (max-width: 860px)": {
        marginLeft: spacing(-3),
        marginRight: spacing(-3),
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }
    },
    titleText: {
      color: palette.text.primary,
      fontWeight: 500
    },
    contentArea: {
      flex: 1,
      overflow: "auto",
      padding: spacing(2, 6)
    }
  })
)
